"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNetworkAdmin = exports.NetworkAdminRoles = void 0;
// Claims types
exports.NetworkAdminRoles = {
    Admin: "admin",
};
var isNetworkAdmin = function (claims, networkId) { var _a, _b; return (_b = (_a = claims.networks) === null || _a === void 0 ? void 0 : _a[networkId]) === null || _b === void 0 ? void 0 : _b.roles.includes(exports.NetworkAdminRoles.Admin); };
exports.isNetworkAdmin = isNetworkAdmin;
//# sourceMappingURL=NetworkAdmin.js.map